import type { CardPaymentFormFields } from '@cencosud-cencommerce/paris-uikit';

export const DEFAULT_FORM_VALUES: Partial<CardPaymentFormFields> = {
  cvv: '',
  fees: '1',
  terms: true
};
